function reducer(state = [], action) {

    switch (action.type) {
        case 'DUES/SET':
            return action.dues;
        case 'DUES/ADD':
            return [...state, action.due];
        case 'DUES/REMOVE':
            return [...state.slice(0, action.index), ...state.slice(action.index + 1)];
        case 'DUES/UPDATE':
            return [...state.slice(0, action.index), action.due, ...state.slice(action.index + 1)];
        case 'DUES/POP':
            state.pop();
            return [...state];
        default:
            return state;
    }
}

export default reducer;
